import { render, staticRenderFns } from "./homePieTwo.vue?vue&type=template&id=7b9ae2a2&scoped=true"
import script from "./homePieTwo.vue?vue&type=script&lang=js"
export * from "./homePieTwo.vue?vue&type=script&lang=js"
import style0 from "./homePieTwo.vue?vue&type=style&index=0&id=7b9ae2a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b9ae2a2",
  null
  
)

export default component.exports